module.exports = "/images/vendor/vue2vis/dist/addNodeIcon.png?a1a2d01bcd034270a3bc92176edfb66c";